import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon'

export const ArrowBidirectional = Styled(
	createSvgIcon(
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M17.28 10.45L21 6.72998L17.28 3.01001"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path d="M3 6.72998H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
			<path
				d="M6.71997 13.55L3 17.2701L6.71997 20.9901"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path d="M21 17.27H3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</svg>,
		'ArrowBidirectionalIcon'
	)
)

export default ArrowBidirectional
